import { stdChannel } from './channel';
import { taskProcessor } from './taskProcessor';
import { immediately } from './taskSchedule';
import { getMetaInfo, wrapSagaDispatch } from './utils';

const sagaLogError = (error, { sagaStack }) => {
	// console.error(error);
	console.error(sagaStack);
};
export const runSaga = (
	{ channel = stdChannel(), dispatch, getState },
	saga,
	...args
) => {
	// generate iterator
	const iterator = saga(...args);

	// 整理创建task时需要的环境信息
	const env = {
		channel,
		dispatch: wrapSagaDispatch(dispatch),
		getState,
		onError: sagaLogError,
	};

	return immediately(() => {
		return taskProcessor(env, iterator, getMetaInfo(saga), true, undefined);
	});
};
